import nftfyWhite from '@assets/nftfy/nftfy-white.svg'
import { productMenu } from '../../services/ProductMenuService'
import Header from '../design-system/header/Header'

interface ProfileHeaderProps {
  chainId: number
  account?: string
}

export default function ProfileHeader({ chainId, account }: ProfileHeaderProps) {
  const logo = {
    image: nftfyWhite.src,
    name: 'Profile',
    href: `/profile/${chainId}/${account}?tokenType=collection`
  }

  const isWalletConnected = !!account

  if (!isWalletConnected) {
    return <Header logo={logo} menu={[]} productMenu={productMenu(chainId)} />
  }

  const menu = [
    {
      name: 'Collections',
      href: `/profile/${chainId}/${account}?tokenType=collection`,
      activeHref: ['/profile/[chainId]/[account]'],
      activeParams: ['collection']
    },
    {
      name: 'Listed',
      href: `/profile/${chainId}/${account}?tokenType=listed`,
      activeHref: ['/profile/[chainId]/[account]'],
      activeParams: ['listed']
    },
    {
      name: 'Fractions',
      href: `/profile/${chainId}/${account}?tokenType=fractions`,
      activeHref: ['/profile/[chainId]/[account]'],
      activeParams: ['fractions']
    },
    {
      name: 'Pools',
      href: `/profile/${chainId}/${account}?tokenType=pools`,
      activeHref: ['/profile[chainId]/[account]'],
      activeParams: ['pools']
    },
    {
      name: 'Private Pools',
      href: `/profile/${chainId}/${account}?tokenType=privatePools`,
      activeHref: ['/profile[chainId]/[account]'],
      activeParams: ['privatePools']
    }
  ]

  return <Header logo={logo} menu={menu} productMenu={productMenu(chainId)} />
}
